import React from 'react'

const CustomSpinLoader = ({loading}) => {
  return (
    loading && (
      <div className = "loading-blur">
        <div className = "loader"></div>
      </div>
    )
  )
}

export default CustomSpinLoader